import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../../data/navigation';
import { Brand } from './Brand';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);
  const isActive = (to: string) => {
    if (to === '/') return pathname === '/' && !hash;
    if (to.startsWith('/#')) return pathname === '/' && hash === to.slice(1);
    return pathname === to;
  };
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${scrolled ? 'border-white/10 bg-ink/90 backdrop-blur-xl' : 'border-white/5 bg-transparent'}`} data-id="element-328" data-mp="3uejycm3h15k7">
      <div className="mx-auto flex max-w-8xl items-center justify-between gap-6 px-5 py-4 sm:px-8 lg:px-10" data-id="element-329" data-mp="bsf4clire0qt">
        <Brand data-id="element-330" data-mp="lkl2ye3ingez" />

        <nav aria-label="Primary" className="hidden items-center gap-0.5 lg:flex" data-id="element-331" data-mp="ll2w31uvteio">
          {navItems.map(item => <Link key={item.label} to={item.to} className={`relative whitespace-nowrap rounded-lg px-3 py-2 text-[13.5px] font-medium transition-colors ${isActive(item.to) ? 'text-white' : 'text-mist-300 hover:text-white'}`} data-id="element-332" data-mp="3k38gambylafg">
              {item.label}
              {isActive(item.to) && <span className="absolute inset-x-3 -bottom-0.5 h-[2px] rounded-full bg-forge-orange" aria-hidden="true" data-id="element-333" data-mp="19ax9pln0z73z" />}
            </Link>)}
        </nav>

        <div className="hidden lg:block" data-id="element-334" data-mp="3ac4vrdgu4ghv">
          <Link to="/#get-started" className="group inline-flex items-center gap-2 rounded-[10px] bg-forge-orange px-5 py-2.5 text-[13.5px] font-bold text-ink shadow-ember transition-transform hover:-translate-y-0.5" data-id="element-335" data-mp="3ab24h4floc1f">
            Discuss Your Project
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-336" data-mp="3ef1m5qcm9gwd" />
          </Link>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" className="grid h-11 w-11 place-items-center rounded-[10px] border border-white/15 text-white lg:hidden" data-id="element-337" data-mp="2qm1h3kodgac6">
          <span className="sr-only" data-id="element-338" data-mp="2vm62np44zv99">{open ? 'Close menu' : 'Open menu'}</span>
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-339" data-mp="27wbp15bzu2ny" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-340" data-mp="22z34iy3dhmjj" />}
        </button>
      </div>

      <AnimatePresence data-id="element-341" data-mp="igsmj8tm62jf">
        {open && <motion.div id="mobile-nav" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.24,
        ease: 'easeOut'
      }} className="overflow-hidden border-t border-white/10 bg-ink/95 lg:hidden" data-id="element-342" data-mp="ifzc9xvg4uwj">
            <nav aria-label="Mobile" className="mx-auto flex max-w-8xl flex-col px-5 py-3 sm:px-8" data-id="element-343" data-mp="124rwihgct5ns">
              {navItems.map(item => <Link key={item.label} to={item.to} className="border-b border-white/5 px-1 py-3.5 text-[15px] font-medium text-mist-100" data-id="element-344" data-mp="16523nxfvu248">
                  {item.label}
                </Link>)}
              <Link to="/#get-started" className="mt-4 mb-2 rounded-[10px] bg-forge-orange px-4 py-3.5 text-center text-[15px] font-bold text-ink" data-id="element-345" data-mp="3cwjp2cird4qi">
                Discuss Your Project
              </Link>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}